import styled from 'styled-components';

export const SubmitButtonTextWrapper = styled.div``;
export const SubmitButtonText = styled.div``;
export const SubmitButtonFrame = styled.div`
  display: none;
`;
